import React from 'react'
import { Icon, Tooltip } from 'antd'

const formatEstimatedDuration = durationValue => {
  const numericDuration = Number.parseFloat(durationValue)
  if (!Number.isFinite(numericDuration) || numericDuration <= 0) return null

  if (Number.isInteger(numericDuration)) {
    return `${numericDuration}`
  }

  return `${Number(numericDuration.toFixed(2))}`
}

const EstimatedDurationBadge = ({
  durationValue,
  className = 'shot-title__estimated'
}) => {
  const estimatedDuration = formatEstimatedDuration(durationValue)

  if (!estimatedDuration) return null

  const tooltipText = `Estimated shot duration is ${estimatedDuration}s. If the generated clip length looks incorrect, please regenerate this shot.`

  return (
    <Tooltip title={tooltipText} trigger={['hover', 'focus', 'click']}>
      <span className={className}>
        <Icon type="clock-circle" />
        <span>Est. {estimatedDuration}s</span>
      </span>
    </Tooltip>
  )
}

export default EstimatedDurationBadge
